import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ServerInferRequest } from "@ts-rest/core";
import { checkContract } from "@common/contracts/check.contract";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { invalidateCashItemQueries } from "./cashItemQueries";

export const checksContractClient = getBackendAPIClient(checkContract);

export function useCreateCheckMutation() {
    const { workspaceId } = useScope();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (
            body: ServerInferRequest<typeof checkContract.createCheck>["body"],
        ) => {
            if (!workspaceId) {
                throw new Error("Workspace is required");
            }

            const { body: response } = await checksContractClient.createCheck({
                params: { workspaceId },
                body,
            });

            return response;
        },
        onSuccess: async () => {
            await invalidateCashItemQueries({ queryClient, workspaceId });
        },
    });
}
